<div
  class="font-sans antialiased text-slate-900 dark:text-slate-100 bg-slate-50 dark:bg-slate-950 transition-colors duration-500 overflow-hidden relative selection:bg-blue-500/30">

  <!-- Background Layers -->
  <div class="fixed inset-0 z-0 bg-slate-50 dark:bg-[#050A14] transition-colors duration-500"></div>

  <!-- Abstract Shapes -->
  <div class="fixed inset-0 z-0 overflow-hidden pointer-events-none">
    <div
      class="absolute -top-[10%] -left-[10%] w-[50vw] h-[50vw] rounded-full bg-blue-600/20 blur-[120px] mix-blend-multiply dark:mix-blend-screen animate-pulse"
      style="animation-duration: 10s"></div>
    <div
      class="absolute top-[20%] right-[10%] w-[30vw] h-[30vw] rounded-full bg-purple-500/20 blur-[100px] mix-blend-multiply dark:mix-blend-screen animate-pulse"
      style="animation-duration: 12s; animation-delay: 1s;"></div>
    <div
      class="absolute -bottom-[10%] left-[20%] w-[40vw] h-[40vw] rounded-full bg-teal-500/20 blur-[100px] mix-blend-multiply dark:mix-blend-screen animate-pulse"
      style="animation-duration: 15s; animation-delay: 2s;"></div>
  </div>

  <div class="hidden lg:flex absolute top-0 left-0 w-full z-50 px-6 py-4 flex justify-end items-center">
       
    <!-- Buttons -->
    <div class="flex items-center gap-3">
      <button (click)="toggleTheme()" class="rounded-full w-10 h-10 flex items-center justify-center 
         bg-white/40 hover:bg-white/60 dark:bg-black/20 dark:hover:bg-black/40 
         backdrop-blur-md border border-white/20 dark:border-white/10 shadow-sm 
         transition-all hover:scale-105 cursor-pointer">
        <i class="bi" [ngClass]="isDark ? 'bi-moon-fill text-yellow-400' : 'bi-lightbulb-fill text-yellow-400'"></i>
      </button>


      <button (click)="toggleLanguage()"
        class="rounded-full px-3 h-10 flex items-center bg-gov-navy text-white hover:bg-blue-900 dark:bg-blue-600 dark:hover:bg-blue-500 shadow-md transition-all hover:scale-105 border border-transparent cursor-pointer">
        <i class="bi bi-globe me-2"></i>
        <span id="lang-text" class="text-xs font-bold tracking-wide">
          {{ !isEnglish ? 'HINDI' : 'ENGLISH' }}
        </span>
      </button>
    </div>
  </div>
  <div class="fixed inset-0 z-0 texture-overlay"></div>



  <!-- Main Content -->
  <div class="z-10 w-full flex items-center justify-center p-4 lg:p-8 relative h-auto lg:h-screen ">

    <div
      class="w-full max-w-6xl h-full lg:h-[100%] flex flex-col lg:flex-row overflow-hidden rounded-[2rem] shadow-2xl glass-panel ring-1 ring-black/5 dark:ring-white/5">


      <!-- Left Panel (Hero) -->
      <div class="relative hidden lg:flex w-1/2 flex-col justify-between p-12 overflow-hidden group">

        <!-- Background Image Placeholder -->
        <div class="absolute inset-0 z-0 bg-gradient-to-br from-blue-900/90 to-slate-900/90 mix-blend-multiply z-10">
        </div>

        <!-- You would replace the src below with the actual background image -->
        <img src="../../assets/images/background.png"
          alt="Background"
          class="absolute inset-0 w-full h-full object-cover opacity-40 scale-105 transition-transform duration-[20s] ease-linear group-hover:scale-110 z-[-1]">

        <div class="relative z-20">
          <!-- <div
            class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur-md border border-white/10 text-blue-100 text-xs font-medium mb-6">
            <span class="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
            Official Portal
          </div> -->
          <div>
            <div class="mb-6 flex justify-center">
              <img src="../../assets/images/logos/hplogo.png" alt="HP Logo" class="w-32 h-auto object-contain">
            </div>
          </div>
          <h1 id="hero-title" class="text-5xl font-bold font-heading text-white leading-[1.15] mb-6 drop-shadow-sm">
            {{ translations.heroTitle }}
          </h1>
          <p id="hero-desc" class="text-blue-100/80 text-lg leading-relaxed max-w-md">
            {{ translations.heroDesc }}
          </p>
        </div>

        <div class="relative z-20 space-y-6">
          <div class="grid grid-cols-2 gap-4">
            <!-- <div class="bg-white/5 p-4 rounded-xl flex flex-col items-center justify-center">
              <i class="bi bi-shield-check text-yellow-400 text-2xl mb-2"></i>
              <p class="text-white font-medium">Secure</p>
            </div>
            <div class="bg-white/5 p-4 rounded-xl flex flex-col items-center justify-center">
              <i class="bi bi-check-circle text-yellow-400 text-2xl mb-2"></i>
              <p class="text-white font-medium">Verified</p>
            </div> -->

          </div>
          <p id="footer-text" class="text-xs text-blue-200/60 font-medium tracking-wide">
            © {{ currentYear }} Government of Himachal Pradesh
          </p>

        </div>
      </div>

      <!-- Right Panel (Login Form) -->
      <div
        class="w-full lg:w-1/2 bg-white/40 dark:bg-black/20 backdrop-blur-md flex flex-col justify-center p-8 sm:p-12 lg:p-16 relative">

        <div class="max-w-sm mx-auto w-full space-y-8">

          <div class="text-center lg:text-left space-y-2 flex justify-between">
            <h2 id="welcome-text" class="text-3xl font-bold text-slate-800 dark:text-white tracking-tight">
              {{ translations.welcomeBack }}
            </h2>
<a href="#" [routerLink]="['/home']" class="brand">
                <!-- <div class="emblem"  style="cursor: pointer;">
                    <img src="../../assets/images/logos/hplogo.png" alt="HP Logo">
                        <span class="brand-name"></span>
                </div> -->

                <div class="brand-text">
                    <span class="brand-name">Home</span>
                    <!-- <span class="brand-sub">Government of Himachal Pradesh</span> -->
                </div>
            </a>
          </div>


<!-- FORM -->
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-5">

            <!-- USERNAME -->
            <div>
              <label class="text-xs font-semibold uppercase">
                {{ translations.username }}
              </label>
              <input type="text" formControlName="UserId" class="w-full h-12 rounded-xl px-4 border"
                [ngClass]="{'border-red-500': loginForm.get('UserId')?.invalid && isSubmit}" />
            </div>

            <!-- PASSWORD -->
            <div>
              <label class="text-xs font-semibold uppercase">
                {{ translations.password }}
              </label>

              <div class="relative">
                <input #passwordInput type="password" formControlName="Password"
                  class="w-full h-12 rounded-xl px-4 pr-10 border" />
                <button type="button" (click)="togglePassword(passwordInput)"
                  class="absolute right-3 top-3 text-slate-400">
                  👁
                </button>
              </div>
            </div>

            <!-- CAPTCHA -->
            <div>
              <label class="text-xs font-semibold uppercase">
                {{ translations.captcha }}
              </label>

              <div class="flex gap-3 items-center">
                <span  class="px-4 py-2  w-full text-center rounded-xl border">
                  {{ captchaQuestion }}
                </span>

                <input type="text" class="px-4 py-2  w-full text-center rounded-xl border" (input)="captchdata($event)"
                  (paste)="disablePaste($event)" />

                <button type="button" (click)="generateNewCaptcha()" class="px-3">
                  🔄
                </button>
              </div>

              <p *ngIf="errorMessage" class="text-red-500 text-xs mt-1">
                {{ errorMessage }}
              </p>
            </div>

            <!-- REMEMBER -->
            <div class="flex justify-between items-center text-sm">
              <label class="flex gap-2 items-center">
                <input type="checkbox" formControlName="rememberMe" />
                {{ translations.rememberMe }}
              </label>

              <a routerLink="/forgotpassword" class="text-blue-600 font-semibold">
                {{ translations.forgotPassword }}
              </a>
            </div>

            <!-- SUBMIT -->
            <button type="submit" class="w-full h-12 bg-blue-600 text-white rounded-xl font-bold">
              {{ translations.login }}
            </button>


            <p class="text-center text-base text-slate-400">
              Not registered?
              <a class="btn-link text-primary" [routerLink]="['/societyRegistration']">
                SignUp here
              </a>
            </p>



          </form>
        </div>

        <!-- Footer Terms -->
        <!-- <div class="absolute bottom-6 left-0 w-full text-center">
          <p class="text-[10px] uppercase tracking-widest text-slate-400 dark:text-slate-500">
            Secure Access • Encrypted Connection
          </p>
        </div> -->

      </div>
    </div>
  </div>


</div>